"use strict";
import { CHART_TYPE_LABELS } from "components/Charts/utils";
import { DropdownSelector, InternalMenuItem } from "components/DropdownSelector";
import { MouseoverTooltip } from "components/Tooltip";
import { useTheme } from "lib/styled-components";
import { useState } from "react";
import { Check, Info } from "react-feather";
import { Trans } from "react-i18next";
import { isMobileWeb } from "utilities/src/platform";
const StyledDropdownButton = {
  borderRadius: 20,
  width: "100%",
  height: 36
};
function getChartTypeSelectorOption(option) {
  if (typeof option === "string") {
    return { value: option };
  }
  return option;
}
export function ChartTypeDropdown({
  options,
  disabledOption,
  menuLabel,
  currentChartType,
  onSelectOption,
  tooltipText
}) {
  const theme = useTheme();
  const [isMenuOpen, toggleMenu] = useState(false);
  return <DropdownSelector
    isOpen={isMenuOpen}
    toggleOpen={toggleMenu}
    menuLabel={menuLabel ?? CHART_TYPE_LABELS[currentChartType]}
    tooltipText={tooltipText}
    buttonStyle={StyledDropdownButton}
    dropdownStyle={{ minWidth: 130 }}
    alignRight
  >{options.map((option) => {
    const { value: chartType, display } = getChartTypeSelectorOption(option);
    const disabled = chartType === disabledOption;
    return <MouseoverTooltip
      key={chartType}
      text={disabled && <Trans i18nKey="chart.settings.unavailable.label" />}
      placement={!isMobileWeb ? "right" : void 0}
      disabled={!disabled}
    ><InternalMenuItem
      onPress={() => {
        if (disabled) {
          return;
        }
        onSelectOption(chartType);
        toggleMenu(false);
      }}
      disabled={disabled}
    >{display ?? CHART_TYPE_LABELS[chartType]}{chartType === currentChartType && <Check size={20} color={theme.accent1} />}{disabled && <Info size={20} color="$neutral2" />}</InternalMenuItem></MouseoverTooltip>;
  })}</DropdownSelector>;
}
